<template>
  <LayoutLogin>
    <template v-slot:content>
      <LayoutLoginCard class="oAuthCallbackView-card">
        <div class="d-flex justify-center my-6">
          <Logo type="big" />
        </div>

        <LoaderSpinner v-if="isLoading" />
      </LayoutLoginCard>
    </template>
  </LayoutLogin>
</template>

<script>
import isEmpty from 'lodash/isEmpty'

import mixin from '@/mixins/mixin.vue'
import authMixin from '@/mixins/authMixin.vue'
import UserAuthentication from '@/auth'

import LayoutLogin from '@/components/Core/Layout/LayoutLogin'
import LayoutLoginCard from '@/containers/Access/components/LayoutLoginCard.vue'
import Logo from '@/components/Core/Logo/Logo.vue'
import LoaderSpinner from '@/components/utils/LoaderSpinner.vue'

export default {
  name: 'OAuthCallbackView',

  components: {
    LayoutLogin,
    LayoutLoginCard,
    Logo,
    LoaderSpinner,
  },

  mixins: [mixin, authMixin],

  data() {
    return {
      isLoading: true,
    }
  },

  mounted() {
    this.handleRedirect()
  },

  methods: {
    handleRedirect() {
      const { session } = this.$route.query

      if (isEmpty(session)) {
        this.isLoading = false
        return this.replaceRoute({ name: 'access' })
      }

      const auth = new UserAuthentication(window.localStorage)
      const isLoggedIn = auth.isLoggedIn()

      if (isLoggedIn) {
        return this.replaceRoute({
          name: 'OAuthConsent',
          query: { session },
        })
      }

      const redirect = `/oauth/consent?session=${session}`

      return this.navigateTo({
        name: 'access',
        query: { redirect },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.oAuthCallbackView-card {
  max-width: 450px;
  width: 450px;
}
</style>
